'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$12(evaluator$14) {
  this.Lapp_data_AppRegisteredUser$$anon$12__f_evaluator$4 = null;
  this.Lapp_data_AppRegisteredUser$$anon$12__f_evaluator$4 = evaluator$14;
}
export { $c_Lapp_data_AppRegisteredUser$$anon$12 as $c_Lapp_data_AppRegisteredUser$$anon$12 };
$c_Lapp_data_AppRegisteredUser$$anon$12.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$12.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$12;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$12() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$12 as $h_Lapp_data_AppRegisteredUser$$anon$12 };
$h_Lapp_data_AppRegisteredUser$$anon$12.prototype = $c_Lapp_data_AppRegisteredUser$$anon$12.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$12.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$12.prototype.apply__s_Option = (function() {
  var v = this.Lapp_data_AppRegisteredUser$$anon$12__f_evaluator$4.apply__O();
  return ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$is_sci_Map(v) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_data_AppRegisteredUser$$anon$12.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_data_AppRegisteredUser$$anon$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$12, "app.data.AppRegisteredUser$$anon$12", ({
  Lapp_data_AppRegisteredUser$$anon$12: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$12 as $d_Lapp_data_AppRegisteredUser$$anon$12 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$12.js.map
